/* eslint-disable react-hooks/exhaustive-deps */
import classNames from "classnames";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { DropDown } from "components/InputsMex/inputs";
import { TextInput as TextInputX } from "containers/Pymes/componentes/entradas";
import _ from "lodash";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const YES_NO_OPTIONS = [
  {
    label: "SI",
    value: "SI",
  },
  {
    label: "NO",
    value: "NO",
  },
];
const DEFAULT_YES_NO = "SI";

const ComplienceQuestionsInput = ({ configuracion }) => {
  const methods = useFormContext();

  const clienteActuaPorCuentaPropiaProps = useMemo(
    () => ({
      show: _.get(configuracion?.clienteActuaPorCuentaPropia, "show", true),
      name: configuracion?.clienteActuaPorCuentaPropia?.name || "clienteActuaPorCuentaPropia",
      label:
        configuracion?.clienteActuaPorCuentaPropia?.label || "¿El cliente actúa por cuenta propia?",
      options: configuracion?.clienteActuaPorCuentaPropia?.options || YES_NO_OPTIONS,
      defaultValue: configuracion?.clienteActuaPorCuentaPropia?.defaultValue || DEFAULT_YES_NO,
      rules: configuracion?.clienteActuaPorCuentaPropia?.rules || {},
    }),
    [
      configuracion.clienteActuaPorCuentaPropia?.defaultValue,
      configuracion.clienteActuaPorCuentaPropia?.label,
      configuracion.clienteActuaPorCuentaPropia?.name,
      configuracion.clienteActuaPorCuentaPropia?.options,
      configuracion.clienteActuaPorCuentaPropia?.rules,
      configuracion.clienteActuaPorCuentaPropia?.show,
    ]
  );

  const verificacionDatosProps = useMemo(
    () => ({
      show: _.get(configuracion?.verificacionDatos, "show", true),
      name: configuracion?.verificacionDatos?.name || "verificacionDatos",
      label:
        configuracion?.verificacionDatos?.label ||
        "Manifiesto bajo protesta de decir verdad, que he verificado los datos y la información aquí proporcionada, mismos que fueron obtenidos mediante entrevista personal al cliente.",
      options: configuracion?.verificacionDatos?.options || YES_NO_OPTIONS,
      defaultValue: configuracion?.verificacionDatos?.defaultValue || DEFAULT_YES_NO,
      rules: {
        required: "Este campo es obligatorio",
        ...(configuracion?.verificacionDatos?.defaultValue || {}),
      },
    }),
    [
      configuracion.verificacionDatos?.defaultValue,
      configuracion.verificacionDatos?.label,
      configuracion.verificacionDatos?.name,
      configuracion.verificacionDatos?.options,
      configuracion.verificacionDatos?.show,
    ]
  );

  const gastoEstimadoSuperaMontoProps = useMemo(
    () => ({
      show: _.get(configuracion?.gastoEstimadoAnualSuperaMonto, "show", true),
      name: configuracion?.gastoEstimadoAnualSuperaMonto?.name || "gastoEstimadoAnual.superaMonto",
      label:
        configuracion?.gastoEstimadoAnualSuperaMonto?.label ||
        "¿Cuánto estima gastar anualmente en seguros con AIG?",
      options: configuracion?.gastoEstimadoAnualSuperaMonto?.options || [
        {
          label: "Hasta 4 veces el monto del seguro inicial",
          value: {
            label: "Hasta 4 veces el monto del seguro inicial",
            value: "NO",
            codigo: 9,
          },
        },
        {
          label: "Más de 4 veces el monto del seguro inicial",
          value: {
            label: "Más de 4 veces el monto del seguro inicial",
            value: "SI",
            codigo: 9,
          },
        },
      ],
      defaultValue: configuracion?.gastoEstimadoAnualSuperaMonto?.defaultValue || {
        label: "Hasta 4 veces el monto del seguro inicial",
        value: "NO",
        codigo: 9,
      },
      rules: {
        required: "Este campo es obligatorio",
        ...(configuracion?.gastoEstimadoAnualSuperaMonto?.rules || {}),
      },
    }),
    [
      configuracion.gastoEstimadoAnualSuperaMonto?.defaultValue,
      configuracion.gastoEstimadoAnualSuperaMonto?.label,
      configuracion.gastoEstimadoAnualSuperaMonto?.name,
      configuracion.gastoEstimadoAnualSuperaMonto?.options,
      configuracion.gastoEstimadoAnualSuperaMonto?.rules,
      configuracion.gastoEstimadoAnualSuperaMonto?.show,
    ]
  );

  const gastoEstimadoMontoValorProps = useMemo(
    () => ({
      show: _.get(configuracion?.gastoEstimadoAnualMontoAproximado, "show", true),
      name:
        configuracion?.gastoEstimadoAnualMontoAproximado?.name ||
        "gastoEstimadoAnual.montoAproximado",
      label:
        configuracion?.gastoEstimadoAnualMontoAproximado?.label ||
        "Favor de agregar el monto aproximado:",
      rules: {
        required: "Este campo es obligatorio",
        ...configuracion?.gastoEstimadoAnualMontoAproximado?.rules,
      },
    }),
    [
      configuracion?.gastoEstimadoAnualMontoAproximado?.label,
      configuracion?.gastoEstimadoAnualMontoAproximado?.name,
      configuracion?.gastoEstimadoAnualMontoAproximado?.rules,
      configuracion?.gastoEstimadoAnualMontoAproximado?.show,
    ]
  );

  return (
    <React.Fragment>
      {clienteActuaPorCuentaPropiaProps.show &&
        _.isEqual({ label: "Física", value: "F" }, methods.watch("tipoPersona")) && (
          <div className='col-md-6 col-xl-5 my-2'>
            <SimpleContainer
              name={clienteActuaPorCuentaPropiaProps.name}
              label={clienteActuaPorCuentaPropiaProps.label}>
              <DropDown
                name={clienteActuaPorCuentaPropiaProps.name}
                options={clienteActuaPorCuentaPropiaProps.options}
                defaultValue={clienteActuaPorCuentaPropiaProps.defaultValue}
                rules={clienteActuaPorCuentaPropiaProps.rules}
              />
            </SimpleContainer>
          </div>
        )}
      {verificacionDatosProps.show && (
        <div className='col-md-6 col-xl-5 my-2'>
          <SimpleContainer name={verificacionDatosProps.name} label={verificacionDatosProps.label}>
            <DropDown
              name={verificacionDatosProps.name}
              options={verificacionDatosProps.options}
              defaultValue={verificacionDatosProps.defaultValue}
              rules={verificacionDatosProps.rules}
            />
          </SimpleContainer>
        </div>
      )}

      {gastoEstimadoSuperaMontoProps.show && (
        <div className='col-md-6 col-xl-5 my-2'>
          <SimpleContainer
            name={gastoEstimadoSuperaMontoProps.name}
            label={gastoEstimadoSuperaMontoProps.label}>
            <DropDown
              name={gastoEstimadoSuperaMontoProps.name}
              options={gastoEstimadoSuperaMontoProps.options}
              rules={gastoEstimadoSuperaMontoProps.rules}
              defaultValue={gastoEstimadoSuperaMontoProps.defaultValue}
            />
          </SimpleContainer>
        </div>
      )}

      {gastoEstimadoMontoValorProps.show &&
        methods.watch(gastoEstimadoSuperaMontoProps.name)?.value === "SI" && (
          <MaskCurrency
            label={gastoEstimadoMontoValorProps.label}
            name={gastoEstimadoMontoValorProps.name}
            rules={gastoEstimadoMontoValorProps.rules}
          />
        )}
    </React.Fragment>
  );
};

export default ComplienceQuestionsInput;

const MaskCurrency = ({ sources, ...rest }) => {
  const { name, label } = rest;
  return (
    <div
      className={classNames("col-md-6 col-xl-5 my-2", {
        "d-none": rest.hide,
      })}>
      <SimpleContainer label={label} name={name}>
        <TextInputX
          inputProps={{
            name,
            type: "number",
          }}
          numerico={true}
          extrasClasses='hide-arrows'
          {...rest}
        />
      </SimpleContainer>
    </div>
  );
};
